import AnalyticsAsset from './AnalyticsAsset';

export default AnalyticsAsset;
